module.exports = __webpack_public_path__ + "img/group23-zh.57f56f7c.png";